import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MyTicketsStatusEnum } from '../pages/tickets/enums/my-tickets-status-enum';
import { environment } from 'src/environments/environment';
import { NetworkConfig } from '../config/network.config';

@Injectable({
  providedIn: 'root',
})
export class TicketsApiService {
  constructor(private httpClient: HttpClient) {}

  public getMyTickets(
    page?: number,
    take: number = 10,
    current?: MyTicketsStatusEnum
  ): Observable<any> {
    let url =
      environment.apiRoot +
      NetworkConfig.ORDERS +
      '/' +
      NetworkConfig.MY_TICKETS;
    // +
    // '?page=' +
    // page +
    // '&take=' +
    // take;

    if (take) {
      url = url + '?take=' + take;
    }

    if (page) {
      url = url + '&page=' + page;
    }

    if (current) {
      url = url + '&current=' + current;
    }

    return this.httpClient.get<any>(url);
  }
}
